import React from 'react';

import { StyledGrid } from './styles';

const Grid = props => <StyledGrid {...props} />;

export default Grid;
